module.exports = __webpack_public_path__ + "img/IconTreeArea.e9e32e66.svg";